<template>
  <div class="best-price">
    <div class="badge">
      <div class="label">Лучшая цена</div>
    </div>
    <div class="description">Мы гарантируем лучшую цену на этот товар</div>
  </div>
</template>
<style lang="stylus" scoped>
.best-price
  .badge
    height 21px
    border-radius 12px
    background #36BF48
    display flex
    align-items center
    justify-content center
    padding 3px 8px
    width max-content
    
    .label
      font-weight 500
      font-size 12.8px
      line-height 120%
      color #fff
  
  .description
    margin-top 8px
    font-weight 400
    font-size 14px
    line-height 20px
    color #666
</style>
